import * as React from "react"
export const ToolbarForArrow = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={17}
        fill="none"
     viewBox="0 0 20 17"
    {...props}
  >
    <g
      stroke="#6C757D"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    >
      <path d="M17.813 4.795H6.875s-5.208 0-5.208 5.128c0 5.77 5.208 5.77 5.208 5.77h9.078" />
      <path d="m14.688 8.609 3.645-3.814L14.688.98" />
    </g>

  </svg>
)

